import React, { useContext, useEffect, useRef, useState } from "react";
import {
  IonButton,
  IonItem,
  IonLabel,
  IonList,
  IonSearchbar,
  IonAvatar,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonSpinner,
  IonLoading,
  IonHeader,
  IonGrid,
  IonRow,
  IonCol,
  IonTitle,
  IonIcon,
  IonRouterLink,
  IonSegment,
  IonContent,
  IonListHeader,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonAlert,
  IonFooter,
  IonModal,
  IonToolbar,
} from "@ionic/react";
import {
  ApplicationContext,
  ProviderContext,
  ProviderContextProvider,
} from "../ApplicationState";
import * as ApiService from "../services/ApiService";
import * as Helpers from "../services/Helpers";
import { useHistory, useLocation } from "react-router";
import { IUserProps } from "../models/user";
import {
  ArrowForwardCircleSharp,
  BanSharp,
  CheckmarkCircleSharp,
  CheckmarkDoneSharp,
  CloseCircleSharp,
  CloudDownloadSharp,
  CreateSharp,
  InformationCircle,
  InformationCircleOutline,
  InformationOutline,
  PeopleSharp,
} from "react-ionicons";
import saveAs from "save-as";
import {
  arrowBackSharp,
  arrowDown,
  arrowForward,
  arrowForwardCircle,
  arrowForwardSharp,
  arrowUp,
  checkmarkDoneCircleOutline,
  closeCircleOutline,
  expandSharp,
  happyOutline,
  key,
  sadOutline,
} from "ionicons/icons";
import "./Components.css";
import { convertArrayToObject } from "../services/Helpers";
import moment from "moment";
import { useUserProfile } from "../pages/UserProfile/useUserProfile";
import { DataGrid } from "@mui/x-data-grid";
import EditAttributesIcon from '@mui/icons-material/EditAttributes';
import { Box, Button, CircularProgress, ClickAwayListener, IconButton, Paper, Popper, Skeleton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import { usePopper } from "react-popper";
import { AnyARecord } from "dns";

var _ = require("lodash");

const UsersComponent: React.FC<any> = (props: any) => {
  const providerContext = useContext(ProviderContext);
  const history = useHistory();
  const { fetchSelectedUserMeasurement } = useUserProfile();
  const location: any = useLocation();
  const local = useLocation();
  const { userState } = useContext(ApplicationContext);
  const { providerState } = useContext(ProviderContext);
  const [searchText, setSearchText] = React.useState("");
  const [users, setUsers] = React.useState([]);
  const [selectedUser, setState] = React.useState([]);
  const [filteredUsers, setFilteredUsers] = React.useState([]);
  const [tempsearchtext, setTempsearchtext] = React.useState("");
  const [showLoading, setShowLoading] = React.useState(true);
  const [type, setType] = React.useState("");
  const [sortKey, setSortKey] = React.useState("name");
  const [sortDirection, setSortDirection] = React.useState(0);
  const [pageNumber, setPageNumber] = React.useState<number>(1);
  const [pageSize, setPageSize] = React.useState<number>(1000);
  const [disableInfiniteScroll, setDisableInfiniteScroll] =
    useState<boolean>(false);
  const [tooltipData, setTooltipData] = useState({});
  const [loadingId, setLoadingId] = useState(null);
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement);

  useEffect((): any => {
    if (searchText !== "") return
    setShowLoading(true);
    getUsersfromAPi();

  }, [providerState, sortKey, sortDirection, searchText]);

  const containsNumber = (str) => {
    // Check if the string contains any digit between 0 and 9
    return /\d/.test(str);
  }

  // function onUserSelectionChange($event, user) {
  //   //history.push("/readings",{selectedUser:user});
  //   let toUpdate: IUserProps = {};
  //   toUpdate.id = user.username;
  //   toUpdate.username = user.username;
  //   toUpdate.providerCode = user.attributes.find(
  //     (r) => r.name === "custom:providercode"
  //   ).value;
  //   toUpdate.allowAdminAccess = true;
  //   toUpdate.roles = user.roles;
  //   if (user) {
  //     history.push("/userprofile", { userId: user.id, user: user });
  //   }
  // }

  function handleRowClick(params) {
    const user = params.row;
    const isPatient = params.row.isPatient
    const providerCode = user.attributes?.find((r) => r.name === "custom:providercode")?.value || '';
    history.push("/userprofile", { userId: user.id, user: { ...user, providerCode, isPatient } });
  }

  let timer: any;
  // function onSearchTextChange(searchTerm: string) {
  //   clearTimeout(timer);
  //   setSearchText(searchTerm);

  // }
  function onSearchTextChange(searchTerm: string) {
    setSearchText(searchTerm);
    if (searchTerm === "") {
      setFilteredUsers(users); // Reset filtered list to all users
      return;
    }
    setFilteredUsers(
      users.filter((user) => {
        return (
          user.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.lastName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.phone?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      })
    );
  }

  function onUserActivationClick($event, user) {
    var result = convertArrayToObject(user.attributes, "name");
    if (result) {
      result.enabled = user.enabled;
      // Update state if necessary here to force re-render
      setState(result);

      history.push("/updateprofile", { user: result });
    } else {
      console.error("Failed to convert user attributes to object.");
    }
  }

  const LinktoEMRClick = async (user, event) => {
    setReferenceElement(event.currentTarget);
    setLoadingId(user.id);
    try {
      const data = await ApiService.fetchEMRTempData(userState.authenticatedUser, user.id, providerState.providerId);
      setTooltipData((prev) => ({ ...prev, [user.id]: JSON.stringify(data, null, 2) }));
    } catch {
      setTooltipData((prev) => ({ ...prev, [user.id]: "Error fetching data" }));
    }
    setLoadingId(null);
  };

  const rediect = () => {
    if (type === "Users") history.push("/users", { type: "Users" });
    else history.push("/patients", { type: "Patients" });
  };

  function sort(key, direction) {
    if (direction == 1) {
      var sfilteredReadings = filteredUsers.sort((a, b) => {
        const valA = a[key];
        const valB = b[key];
        return valA.localeCompare(valB);
      });
      setFilteredUsers(sfilteredReadings);
    } else if (direction == 2) {
      var sfilteredReadings = filteredUsers.sort((a, b) => {
        const valA = a[key];
        const valB = b[key];
        return valB.localeCompare(valA);
      });
      setFilteredUsers(sfilteredReadings);
    } else {
      setSortDirection(0);
      setSortKey("");
      setFilteredUsers(users);
    }
  }

  const sortBy = (key) => {
    setPageNumber(1);
    if (key == sortKey) {
      setSortDirection((sortDirection % 2) + 1);
      setSortKey(key);
    } else {
      setSortDirection(1);
      setSortKey(key);
    }
  };

  const inputRef = useRef<any>(null);
  const [disableNextButton, setDisableNextButton] = useState<boolean>(false);
  const [disablePrevButton, setDisablePrevButton] = useState<boolean>(false);

  async function LoadNextData($event: CustomEvent<void>) {
    //setPageNumber(pageNumber + 1);

    let userType: any = props.type;
    if (location.state?.type !== undefined) userType = location.state?.type;

    if (providerState !== undefined) {
      if (
        providerState.providerId !== undefined &&
        providerState.providerId !== ""
      ) {
        setShowLoading(true);
        ApiService.fetchUsers(
          userState.authenticatedUser,
          providerState.providerId,
          pageSize,
          pageNumber,
          null,
          null,
          sortKey,
          sortDirection,
          searchText,
          userType
        ).then((data) => {
          if (data && data.length > 0) {
            setUsers(data);
            setFilteredUsers(data);
            setDisableInfiniteScroll(data.length < pageSize);
            setDisableNextButton(data.length < pageSize);
            if (data.length >= pageSize) setPageNumber(pageNumber + 1);
            else setPageNumber(pageNumber - 1);
          } else {
            setDisableInfiniteScroll(true);
            setDisableNextButton(true);
          }
          setShowLoading(false);
          setDisablePrevButton(pageNumber === 1);
          setTimeout(() => inputRef.current.setFocus(), 200);
        });
      }
    }
    //($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  async function LoadPreviousData($event: CustomEvent<void>) {
    // if (pageNumber == 0) return;
    // else setPageNumber(pageNumber - 1);

    let userType: any = props.type;
    if (location.state?.type !== undefined) userType = location.state?.type;

    if (providerState !== undefined) {
      if (
        providerState.providerId !== undefined &&
        providerState.providerId !== ""
      ) {
        setShowLoading(true);
        ApiService.fetchUsers(
          userState.authenticatedUser,
          providerState.providerId,
          pageSize,
          pageNumber,
          null,
          null,
          sortKey,
          sortDirection,
          searchText,
          userType
        ).then((data) => {
          if (data && data.length > 0) {
            setUsers(data);
            setFilteredUsers(data);
            setDisableInfiniteScroll(data.length < pageSize);
            setDisableNextButton(data.length < pageSize);
            if (pageNumber > 1) setPageNumber(pageNumber - 1);
            else setPageNumber(pageNumber + 1);
          } else {
            setDisableInfiniteScroll(true);
            setDisableNextButton(true);
          }
          setShowLoading(false);
          setDisablePrevButton(pageNumber === 1);
          setTimeout(() => inputRef.current.setFocus(), 200);
        });
      }
    }
    //($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  function downloadUserXls() {
    let userType: any = props.type;
    setShowLoading(true)
    ApiService.fetchUserXls(
      userState.authenticatedUser,
      providerState.providerId,
      null,
      null,
      null,
      null,
      sortKey,
      sortDirection,
      searchText,
      userType
    ).then((data) => {
      setShowLoading(false)
      if (data) {
        const downloadedFile = Helpers.base64ToBlob(
          data.fileContents,
          data.contentType
        );
        saveAs(downloadedFile);
      }
    }).catch((err) => {
      setShowLoading(false)
      alert('Downloading failed. Please try again.')
      console.log("error downloadUserXls system user")
    })
  }

  const getUsersfromAPi = () => {
    let isSubscribed = true;
    let user = userState.authenticatedUser;
    let pageNum = 1;
    setPageNumber(1);
    prevbtnref.current?.setAttribute("hidden", "true");
    nextbtnref.current?.setAttribute("hidden", "true");
    let userType: any = props.type;

    const isNumber = containsNumber(searchText)

    if (location.state?.type !== undefined) userType = location.state?.type;

    if (providerState !== undefined) {
      if (
        providerState.providerId !== undefined &&
        providerState.providerId !== ""
      ) {
        setShowLoading(users.length > 0 && searchText === "" && tempsearchtext === "" ? false : true);
        setType(userType);
        ApiService.fetchUsers(
          userState.authenticatedUser,
          providerState.providerId,
          pageSize,
          pageNum,
          null,
          null,
          sortKey,
          sortDirection,
          searchText,
          userType,
          isNumber ? 'number' : 'string',
        ).then((data) => {
          if (isSubscribed) {

            const flattenedData = data?.map((item, index) => ({
              id: index, // required by DataGrid
              ...item.user, // spread the user fields
              linkStatus: item.linkStatus, // add linkStatus as a column
            }));

            if (data) {
              const dataSortbydate = _.orderBy(flattenedData, ['userCreateDate'], ["desc"])
              setPageNumber(pageNumber + 1);
              setUsers(dataSortbydate);
              setFilteredUsers(dataSortbydate);
              setTempsearchtext(searchText)
              setDisableInfiniteScroll(flattenedData.length < pageSize);
              setDisableNextButton(flattenedData.length < pageSize);
            }
            if (flattenedData.length == pageSize) {
              prevbtnref.current?.removeAttribute("hidden");
              nextbtnref.current?.removeAttribute("hidden");
            }
            setShowLoading(false);
            setDisablePrevButton(pageNumber === 1);
          }
        }).catch((err) => {
          setShowLoading(false);
          alert('Something went wrong. Please try again.')
        })
      }
    }
    return () => (isSubscribed = false);
  }

  const search = () => {
    if (searchText !== "") {
      getUsersfromAPi()
    }
  }

  const prevbtnref = useRef<HTMLIonButtonElement>(null);
  const nextbtnref = useRef<HTMLIonButtonElement>(null);


  const InfoButton = ({ rowId }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [loadingId, setLoadingId] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showAlert, setShowAlert] = useState(false);

    const handleFetchData = async (event) => {
      event.stopPropagation();

      // Close any existing popper
      //setAnchorEl(null);
      setLoadingId(true);

      try {
        // Wait a small delay before setting a new anchor element
        //await new Promise((resolve) => setTimeout(resolve, 10)); 
        setAnchorEl(event.currentTarget);

        // Fetch data
        const data = await ApiService.fetchEMRTempData(userState.authenticatedUser, rowId, providerState.providerId);
        setTableData(data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setTableData([]);
      } finally {
        setLoadingId(false);
      }
    };

    const handleRowSelect = async (row) => {
      try {
        setSelectedRow(row);
        handleClosePopper();
        setTimeout(() => setShowAlert(true), 150); // Add delay to ensure visibility
        //const data = await ApiService.updateUserEMRData(userState.authenticatedUser, row);
        //handleClosePopper();
      } catch (error) {
        console.error("Error updating user emr record:");
      } finally {
        setLoadingId(false);
      }
    };

    const confirmUpdate = async (selectedRow: any) => {
      try {
        const data = await ApiService.updateUserEMRData(userState.authenticatedUser, selectedRow);
        handleClosePopper();
      } catch (error) {
        console.error("Error updating user EMR record:");
      } finally {
        setLoadingId(false);
        setShowAlert(false);
      }
    };

    const handleClosePopper = () => {
      setAnchorEl(null);
    };

    const capitalizeFirstLetter = (string) => {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return (
      <>
        <IonModal isOpen={showAlert} onDidDismiss={() => setShowAlert(false)}>
          <IonHeader>
            <IonToolbar>
              <IonTitle>Confirm Update</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <div style={{ textAlign: 'center', margin: '16px 0', fontSize: '1.1em', fontWeight: 'bold' }}>
              Are you sure you want to associate the user with this EMR record?
            </div>
            {selectedRow ? (
              <div style={{ maxWidth: '100%', width: '480px', overflowX: 'auto', margin: '0 auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', whiteSpace: 'nowrap' }}>
                  <thead>
                    <tr>
                      <th style={{ border: '1px solid #ddd', padding: '8px' }}>Field</th>
                      <th style={{ border: '1px solid #ddd', padding: '8px' }}>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(selectedRow).map(([key, value]) => {
                      if (key === "addressJson") {
                        try {
                          //const address = JSON.parse(value);
                          return Object.entries(value).map(([addressKey, addressValue]) => (
                            <tr key={addressKey}>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{addressKey}</td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{addressValue}</td>
                            </tr>
                          ));
                        } catch (error) {
                          return (
                            <tr key={key}>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{key}</td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{value}</td>
                            </tr>
                          );
                        }
                      } else {
                        return (
                          <tr key={key}>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{key}</td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{value}</td>
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>No data available</p>
            )}
          </IonContent>
          <IonFooter>
            <IonToolbar>
              <IonButton slot="start" onClick={() => setShowAlert(false)}>
                Cancel
              </IonButton>
              <IonButton slot="end" onClick={() => confirmUpdate(selectedRow)}>
                Confirm
              </IonButton>
            </IonToolbar>
          </IonFooter>
        </IonModal>
        <IconButton onClick={handleFetchData}>
          <InformationCircleOutline />
        </IconButton>
        <ClickAwayListener onClickAway={handleClosePopper}>

          <Popper open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            placement="bottom-start"
            modifiers={[
              { name: "preventOverflow", options: { boundary: "window", padding: 10 } },
              { name: "flip", options: { fallbackPlacements: ["top", "bottom"] } },
            ]}>
            <Paper elevation={3} sx={{ padding: 2 }}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <strong>User Details</strong>
                <IconButton onClick={handleClosePopper}>
                  <CloseCircleSharp />
                </IconButton>
              </Box>
              {loadingId ? (
                <CircularProgress size={24} />
              ) : (
                <Table size="small" sx={{ cursor: "pointer" }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>DOB</TableCell>
                      <TableCell>GENDER</TableCell>
                      <TableCell>EMAIL</TableCell>
                      <TableCell>PHONE</TableCell>
                      <TableCell>Address</TableCell>
                      <TableCell>FHIR Resource ID</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData && tableData.length > 0 && tableData?.map((row) => (
                      <TableRow
                        key={row.id}
                        onClick={() => handleRowSelect(row.id)}
                        selected={selectedRow === row.id}
                        sx={{
                          backgroundColor: selectedRow === row.id ? "#f0f0f0" : "inherit",
                        }}
                      >
                        <TableCell>{row.fullName}</TableCell>
                        <TableCell>{row.dob}</TableCell>
                        <TableCell>{row.gender}</TableCell>
                        <TableCell>{row.email}</TableCell>
                        <TableCell>{row.phone}</TableCell>
                        <TableCell>{row.addressJson}</TableCell>
                        <TableCell>{row.fhiR_Resource_ID}</TableCell>
                        <TableCell>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent row click event
                              handleRowSelect(row);
                            }}
                          >
                            Validate
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </Paper>
          </Popper>
        </ClickAwayListener>
      </>
    );
  };
  // Define columns for DataGrid
  const columns = [
    {
      field: "avatar",
      headerName: "",
      width: 60,
      renderCell: (params) => (
        <div>
          <img
            src={params.row.image || "/assets/img/noimageavailable.png"}
            alt="avatar"
            style={{ width: 40, height: 40, borderRadius: "50%" }}
          />
        </div>
      ),
    },
    {
      field: "fullName",
      headerName: "Name",
      width: 150,
      renderCell: (params) => {
        return (
          <span
            style={{ color: "rgb(61, 116, 221)", textDecoration: "underline", cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation(); // Prevent triggering handleRowClick 
              handleRowClick(params);
            }}
          >
            {params.value}
          </span>
        )
      },
    },
    { field: "email", headerName: "Username", width: 200 },
    { field: "phone", headerName: "Phone", width: 150 },
    {
      field: "createdDate",
      headerName: "Created",
      width: 200,
      renderCell: (params) => moment(params.value).local().format("YYYY-MM-DD hh:mm a"),
    },
    { field: "providerCode", headerName: "Provider", width: 150, hideable: true },
    {
      field: "role",
      headerName: "Role",
      width: 150,
      renderCell: (params) => {
        //const patientRole = params.row.isPatient ? 'Patient' : (params.value + ' ' + params.row.role === "Provider" ? `(${params.row.providerCode})` : "")
        const userRole = params?.row?.role
        return (
          <span>
            {userRole}
          </span>
        )
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      renderCell: (params) => (
        <EditAttributesIcon className="d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer", color: "#ff751a" }} fontSize="large"
          onClick={(e) => {
            e.stopPropagation(); // Prevent triggering handleRowClick
            onUserActivationClick(null, params.row);
          }}
        >
          Change
        </EditAttributesIcon>
      ),
    },
    // {params?.row?.enabled ? '(Deactivated)' : ' '}
    // {
    //   field: "emr",
    //   headerName: "Emr Info",
    //   width: 100,
    //   renderCell: (params) => (
    //     <InfoButton rowId={params.row.id} />
    //   ),
    // },

    {
      field: "status",
      headerName: "Status",
      width: 100,
      renderCell: (params) => {
        return (
          <IonLabel style={{
            color: !params?.row?.enabled ? 'brown' : 'green',
            backgroundColor: !params?.row?.enabled ? '#FFEBE8' : '#E8FFEB',
            padding: '5px 10px',
            borderRadius: '5px',
          }}>{params?.row?.enabled ? 'Active' : 'Deactivated'}</IonLabel>

        )
      },
    },

    {
      field: "EMRStatus",
      headerName: "EMR Status",
      width: 100,
      renderCell: (params) => {
        return (
          <IonLabel style={{
            color: params?.row?.EMRStatus !== 'Linked' ? 'brown' : 'green',
            backgroundColor: params?.row?.EMRStatus !== 'Linked' ? '#FFEBE8' : '#E8FFEB',
            padding: '5px 10px',
            borderRadius: '5px',
          }}>{params?.row?.EMRStatus}</IonLabel>

        )
      },
    },

  ];

  // Map filteredUsers to rows for DataGrid
  const rows = filteredUsers?.map((user) => {
    const attributes = user.attributes || [];
    return {
      isPatient: !user.allowAdminAccess && !user.allowProviderAccess && !user.allowSupportAccess,
      id: user.username,
      attributes: user.attributes,
      fullName: `${attributes.find((r) => r.name === "given_name")?.value || ''} ${attributes.find((r) => r.name === "family_name")?.value || ''}`.replace(/\b(\w)/g, (s) => s.toUpperCase()),
      email: attributes.find((r) => r.name === "email")?.value || '',
      phone: attributes.find((r) => r.name === "phone_number")?.value || '',
      createdDate: user.userCreateDate || '',
      providerCode: attributes.find((r) => r.name === "custom:providercode")?.value || '',
      enabled: user.enabled,
      role: attributes.find((r) => r.name === "custom:Roles")?.value || '',
      EMRStatus: user.linkStatus,
      image: attributes.find((r) => r.name === "picture")?.value
        ? `data:image/jpeg;base64,${attributes.find((r) => r.name === "picture")?.value}`
        : "/assets/img/noimageavailable.png",
    };
  });
  return (
    <div style={{ width: "100%" }}>
      {/* <div style={{ display: "flex", justifyContent: "center" }}>
        <IonTitle
            hidden={location.pathname === "/users"}>
            List of {Helpers.getDisplayLabel(providerState)}
          </IonTitle>
          <IonTitle
            hidden={
              location.pathname === "/patients" ||
              location.pathname === "/home" ||
              location.pathname === "/"
            }
          >
            List of System Users
          </IonTitle>

        </div> */}
      <IonCardContent style={{ backgroundColor: "white", overflow: "auto", height: "500px", }}>
        <IonSearchbar className="col-4 float-end"
          value={searchText}
          onIonChange={(e) => onSearchTextChange(e.detail.value!)}
          showCancelButton="always"
        ></IonSearchbar>
        <DataGrid
          sx={{
            display: "flex",
            flexDirection: "column-reverse",
            width: "100%",
            backgroundColor: 'white'
          }}
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
            columns: {
              columnVisibilityModel: {
                providerCode: false
              },
            },
          }}
          pageSizeOptions={[5, 10, 25, 50]}
          disableRowSelectionOnClick
          onRowClick={handleRowClick}
          autoHeight={true}
          loading={showLoading} // Add this line
        />
      </IonCardContent>
    </div>
  );
};

export default UsersComponent;
